/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * A list of claim definitions.
 */
export type ClaimsSchemaFieldStructOptionalValueFieldsItem =
    | Truvity.ClaimsSchemaFieldStructOptionalValueFieldsItem.Boolean
    | Truvity.ClaimsSchemaFieldStructOptionalValueFieldsItem.Date_
    | Truvity.ClaimsSchemaFieldStructOptionalValueFieldsItem.Datetime
    | Truvity.ClaimsSchemaFieldStructOptionalValueFieldsItem.File_
    | Truvity.ClaimsSchemaFieldStructOptionalValueFieldsItem.Link
    | Truvity.ClaimsSchemaFieldStructOptionalValueFieldsItem.Number
    | Truvity.ClaimsSchemaFieldStructOptionalValueFieldsItem.String
    | Truvity.ClaimsSchemaFieldStructOptionalValueFieldsItem.Struct;

export namespace ClaimsSchemaFieldStructOptionalValueFieldsItem {
    export interface Boolean extends Truvity.ClaimsSchemaFieldBooleanValue {
        kind: 'BOOLEAN';
    }

    export interface Date_ extends Truvity.ClaimsSchemaFieldDateValue {
        kind: 'DATE';
    }

    export interface Datetime extends Truvity.ClaimsSchemaFieldDateTimeValue {
        kind: 'DATETIME';
    }

    export interface File_ extends Truvity.ClaimsSchemaFieldFileValue {
        kind: 'FILE';
    }

    export interface Link extends Truvity.ClaimsSchemaFieldLinkValue {
        kind: 'LINK';
    }

    export interface Number extends Truvity.ClaimsSchemaFieldNumberValue {
        kind: 'NUMBER';
    }

    export interface String extends Truvity.ClaimsSchemaFieldStringValue {
        kind: 'STRING';
    }

    export interface Struct extends Truvity.ClaimsSchemaFieldStructOptionalValue {
        kind: 'STRUCT';
    }
}
